<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :data-color="backgroundColor" :class="pageClass">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple | black" -->
        <div class="content">
          <div class="container">
            <slot></slot>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="copyright">
            <!-- &copy; coded with
            <i class="fa fa-heart heart"></i> by
            <a href="https://ederit.com" target="_blank">ederit</a> -->
          </div>
        </footer>

        <div class="full-page-background"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageClass: {
      type: String,
      default: 'login-page'
    },
    backgroundColor: {
      type: String,
      default: process.env.VUE_APP_STYLE ? process.env.VUE_APP_STYLE : 'ederit',
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style>
</style>
